var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcHasRaiseHand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFDD67",
  d: "M6.414 4.504c-.717 0-1.273.57-1.273 1.272v9.311h2.546v-9.31c0-.704-.555-1.273-1.273-1.273m6.857 10.583h2.711V4.467c0-.711-.606-1.304-1.352-1.304h-.007c-.746 0-1.352.593-1.352 1.325z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1833D",
  d: "M14.63 3.163h-.007q-.121.002-.237.023c.632.11 1.113.648 1.113 1.281v10.62h.483V4.467c0-.711-.606-1.304-1.352-1.304"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFDD67",
  d: "M7.687 15.087h2.792V4.25c0-.757-.624-1.37-1.394-1.37h-.004c-.77 0-1.394.614-1.394 1.37z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1833D",
  d: "M9.085 2.88h-.004q-.12.001-.24.023c.655.112 1.156.67 1.156 1.347v6.745l.482.68V4.25c0-.756-.624-1.37-1.394-1.37"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFDD67",
  d: "M10.478 14.207h2.793V3.37c0-.757-.625-1.37-1.394-1.37h-.005c-.77 0-1.394.613-1.394 1.37z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1833D",
  d: "M11.877 2h-.005q-.121.002-.238.023c.655.113 1.155.67 1.155 1.347v7.624l.482.68V3.37c0-.757-.624-1.37-1.394-1.37M6.413 4.504q-.124.001-.24.023a1.26 1.26 0 0 1 1.031 1.249v5.535l.483.68V5.776c0-.703-.556-1.272-1.274-1.272"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFDD67",
  d: "M21.89 10.634c-.51-.97-2.15-.923-3.822.858-1.168 1.244-1.417 1.632-2.589 1.63V11.82s-10.363.044-10.363.835c0 0-.483 3.515.522 5.725 1.497 3.292 8.577 3.785 11.55-1.565 1.752-3.156 5.259-5.115 4.702-6.18"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1833D",
  d: "M21.89 10.634a1.13 1.13 0 0 0-.405-.437q.042.058.077.122c.558 1.065-1.107 2.183-2.3 3.317-.961.912-1.854 1.872-2.337 2.985-2.103 4.857-8.162 4.856-10.713 2.623 2.318 2.539 8.841 2.77 11.04-2.308.483-1.114 1.334-2.022 2.336-2.985 1.187-1.141 2.859-2.252 2.302-3.317"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1833D",
  d: "M15.834 13.108c-1.928-.652-5.911.641-5.388 4.326 0-3.45 3.226-4.312 5.001-4.312.213 0 .387-.014.387-.014"
})));
export default SvgIcHasRaiseHand;